import { Form, Input, Button, message } from "antd";
import { changePassword } from "./api/user";
import { useNavigate } from "react-router-dom";

export default function ChangePassword() {
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      await changePassword(values);
      message.success("密码修改成功，请重新登录");
      localStorage.removeItem("token");
      navigate("/login");
    } catch (err) {
      message.error(err.response?.data?.msg || "修改失败");
    }
  };

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      style={{ maxWidth: 400, margin: "50px auto" }}
    >
      <Form.Item
        label="旧密码"
        name="oldPassword"
        rules={[{ required: true, message: "请输入旧密码" }]}
      >
        <Input.Password />
      </Form.Item>

      <Form.Item
        label="新密码"
        name="newPassword"
        rules={[
          { required: true, message: "请输入新密码" },
          { min: 8, message: "密码至少 8 位" },
        ]}
      >
        <Input.Password />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" block>
          修改密码
        </Button>
      </Form.Item>
    </Form>
  );
}
